import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type {
  CreateReportOptionRequest,
  CreateReportOptionResponse,
} from '../../../../shared/types/routes/reportOptions';

import { getReportOptionsQueryKey } from './useReportOptions';

function createReportOption(
  data: CreateReportOptionRequest,
): Promise<Response & { data?: CreateReportOptionResponse }> {
  return post<CreateReportOptionRequest, CreateReportOptionResponse>('/api/report-options', data);
}

/**
 * Hook for creating a new saved report option.
 *
 * @param organizationId - Used to invalidate the report options query cache after creation.
 */
export function useCreateReportOption(organizationId: number) {
  return useToastedMutation({
    mutationFn: createReportOption,
    successToastMessage: 'Report option saved successfully.',
    errorToastMessage: 'Failed to save report option.',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getReportOptionsQueryKey(organizationId) });
    },
  });
}
